'use client';

import React, { useEffect, useState } from 'react';

import JobCard from './JobCard';

type Props = {
    jobs: any[];
};

export default function JobsList({ jobs }: Props) {
    const [cities] = useState(
        jobs
            .map((j) => j.city)
            .filter((c, index, self) => index === self.findIndex((c2) => c2.slug === c.slug))
            .sort((a, b) => a.name.localeCompare(b.name)),
    );
    const [items, setItems] = useState<any[]>(jobs);
    const [selectedCity, setSelectedCity] = useState('');

    useEffect(() => {
        const items = !!selectedCity ? jobs.filter((j: any) => j.city?.slug === selectedCity) : jobs;
        setItems(items);
    }, [selectedCity, jobs]);

    return (
        <>
            {cities.length > 1 && (
                <div className="mb-4 md:w-1/2 md:pr-2 lg:w-1/3">
                    <select onChange={(e) => setSelectedCity(e.target.value)}>
                        <option value="">Oraș</option>
                        {cities?.map((c) => (
                            <option key={c.slug} value={c.slug}>
                                {c.name}
                            </option>
                        ))}
                    </select>
                </div>
            )}
            <ul className="flex grid-cols-2 flex-wrap gap-4 md:grid lg:gap-8">
                {items.map((job) => (
                    <li key={job.slug} className="w-full bg-white p-4 md:w-auto lg:p-8">
                        <JobCard job={job} />
                    </li>
                ))}
            </ul>
        </>
    );
}
